import { isNullish } from 'remeda';
import { PLATFORM_PARTNER_ID } from 'src/constants/platform';

export function buildManagementQueryParams(
  partnerId: number | null | undefined,
  includePlatformLevelData: boolean,
) {
  if (isNullish(partnerId)) return null;
  const partnerIds = includePlatformLevelData ? [PLATFORM_PARTNER_ID, partnerId] : [partnerId];
  return {
    filters: [
      {
        attribute: 'partnerId',
        operator: 'in',
        value: partnerIds.join(','),
      },
    ],
    ignorePage: true,
  };
}
